import translationalTeamApi from "../../api/translationalTeams";

const state = {
  translationalTeam: {},
  translationalTeamRoles: []
};

const getters = {};

const actions = {
  getTranslationalTeam(context, translationalTeamId) {
    translationalTeamApi
      .getTranslationalTeam(translationalTeamId)
      .then(function(response) {
        context.commit("updateTranslationalTeam", response.data);
      })
      .catch(function(error) {
        console.log(error);
      });
  },
  getTranslationalTeamRoles(context) {
    translationalTeamApi
      .getTranslationalTeamRoles()
      .then(function(response) {
        context.commit("updateTranslationalTeamRoles", response.data);
      })
      .catch(function(error) {
        console.log(error);
      });
  },

  resetStudentOpportunity(context) {
    context.commit("updateOpportunityId", null);
    context.commit("updateStudentAsuriteId", null);
    context.commit("updateStudentOpportunityTypeId", null);
    context.commit("updatePrimarySelection", null);
  }
};

const mutations = {
  updateTranslationalTeam(state, value) {
    state.translationalTeam = value;
  },
  updateTranslationalTeamRoles(state, value) {
    state.translationalTeamRoles = value;
  },
  updateOpportunityId(state, value) {
    state.newStudentOpportunity.opportunityId = value;
  },

  updateStudentAsuriteId(state, value) {
    state.newStudentOpportunity.asuriteId = value;
  },

  updatePrimarySelection(state, value) {
    state.newStudentOpportunity.primarySelection = value;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
